var HtmlComponent_default = {
  "htmlComponent": "bYOh7",
  "htmlComponent_placeholder": "cPsSl"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
